import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import type { JurisdictionOption, LayerDefinition, LayerId } from '@/lib/api/types';

interface JurisdictionGridProps {
  layers: LayerDefinition[];
  jurisdictions: JurisdictionOption[];
  values: Record<string, string | undefined>;
  onChange: (layer: LayerId, value: string) => void;
}

/**
 * One question covering five layers. The dependency index says how deeply the customer is
 * locked in; the jurisdiction profile adds who they are locked in to. Kept on a single screen
 * because the five answers are read together, not one at a time.
 */
export function JurisdictionGrid({ layers, jurisdictions, values, onChange }: JurisdictionGridProps) {
  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      {layers.map((layer) => (
        <Box
          key={layer.id}
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '11rem 1fr' },
            alignItems: 'center',
            gap: 1.5,
          }}
        >
          <Typography component="label" htmlFor={`jurisdiction-${layer.id}`} sx={{ fontWeight: 560 }}>
            {layer.name}
          </Typography>

          <TextField
            id={`jurisdiction-${layer.id}`}
            select
            value={values[layer.id] ?? ''}
            onChange={(event) => onChange(layer.id, event.target.value)}
          >
            {jurisdictions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      ))}
    </Box>
  );
}
